import React, { useEffect, useRef, useState } from 'react'
import { Button, Form, Input } from 'antd'
import { ChromePicker } from 'react-color'
import { isEqual } from 'lodash-es'
import { useIntl } from 'react-intl'
import { useSelector } from 'react-redux'
import { usePrevious } from 'utils/hooks'
import { websiteIdSelector } from 'app-redux/selectors'
import styles from './styles.module.scss' // website_id ini di allow karena sudah ada

// website_id ini di allow karena sudah ada
// nama tag yang melanggar dari rules. Sehingga BE dan FE
// membuat rules special untuk user dengan website_id ini
export const specialWebsiteIdForTagValidation = [
  125376, // AllSet Event Hire
  125564, // PT Eticon Rekayasa Teknik
  130013, // SATRIO LANGIT TRANS
  84919, // PT Adinata Manunggal Perkasa
  150989, // Mitra Visual Group
  171458, // MDLY
]

export const getSpecialRegex = (isSpecialWebsiteId) =>
  isSpecialWebsiteId ? /^[ A-Za-z0-9_@./#&+-]*$/ : /^[\w\s./-]+$/

const FinanceTagForm = ({ innerRef, show, submitHandler, tag }) => {
  const [color, setColor] = useState('#E4E9F0')
  const [displayColorPicker, setDisplayColorPicker] = useState(false)

  const nameRef = useRef()

  const [form] = Form.useForm()
  const { formatMessage } = useIntl()
  const websiteId = useSelector(websiteIdSelector)

  useEffect(() => {
    if (nameRef.current) {
      setTimeout(() => nameRef.current.focus(), 200)
    }
    if (show && tag) {
      setColor(tag ?? '#E4E9F0')
    }
  }, [innerRef, show, tag])

  const prevShow = usePrevious(show)
  const prevTag = usePrevious(tag)

  useEffect(() => {
    if (show && !isEqual(tag, prevTag)) {
      setColor(tag?.color ?? '#E4E9F0')
    }
  }, [color, innerRef, prevShow, prevTag, show, tag])

  const isSpecialWebsiteId = specialWebsiteIdForTagValidation.includes(websiteId)
  const maxTagName = isSpecialWebsiteId ? 150 : 50
  const specialRegex = getSpecialRegex(isSpecialWebsiteId)

  return (
    <Form
      form={form}
      id="tagForm"
      ref={innerRef}
      layout="vertical"
      initialValues={{ name: tag?.name ?? null, color: tag?.color ?? color }}
      onFinish={submitHandler}
    >
      <Form.Item
        label={formatMessage({ id: 'financeTag.name' })}
        name="name"
        rules={[
          {
            required: true,
            message: formatMessage({ id: 'financeTag.please_input_the_tag_name' }),
          },
          {
            max: maxTagName,
            message: formatMessage({ id: 'financeTag.max_characters' }, { value: maxTagName }),
          },
          {
            min: 2,
            message: formatMessage({ id: 'financeTag.min_characters' }, { value: 2 }),
          },
          {
            pattern: specialRegex,
            message: formatMessage({
              id: isSpecialWebsiteId
                ? 'financeTag.alphanumeric_and_this_regex_allowed'
                : 'financeTag.only_alphanumeric_and_dot_allowed',
            }),
          },
        ]}
      >
        <Input ref={nameRef} placeholder={formatMessage({ id: 'financeTag.name' })} autoFocus />
      </Form.Item>
      <Form.Item name="color" label={formatMessage({ id: 'tags.choose_a_color' })}>
        <Button
          htmlType="button"
          className={styles.buttonPickerColor}
          onClick={() => {
            setDisplayColorPicker((prevState) => !prevState)
          }}
        >
          <div style={{ '--tag-color': color }} />
          <p className="mb-0 ml-2 mr-1">{color}</p>
        </Button>
        {displayColorPicker ? (
          <div className={styles.picker}>
            <button
              type="button"
              className={styles.overlay}
              onClick={() => setDisplayColorPicker(false)}
            />
            <ChromePicker
              color={color}
              disableAlpha
              onChange={(newColor) => {
                innerRef.current.setFieldValue('color', newColor.hex)
                setColor(newColor.hex)
              }}
            />
          </div>
        ) : null}
      </Form.Item>
    </Form>
  )
}

export default React.forwardRef((props, ref) => <FinanceTagForm innerRef={ref} {...props} />)
